const local: App.I18n.Schema = {
  system: {
    title: 'IoT Operations Management Platform',
    firstDesc: 'IoT development, IoT operation',
    sedDesc: 'Easier & Faster',
    name: 'Operation management platform'
  },
  common: {
    action: 'Action',
    add: 'Add',
    addSuccess: 'Add Success',
    backToHome: 'Back to home',
    batchDelete: 'Batch Delete',
    cancel: 'Cancel',
    close: 'Close',
    check: 'Check',
    expandColumn: 'Expand Column',
    columnSetting: 'Column Setting',
    resetColumn: 'Reset Column',
    config: 'Config',
    confirm: 'Confirm',
    delete: 'Delete',
    deleteSuccess: 'Delete Success',
    confirmDelete: 'Are you sure you want to delete?',
    edit: 'Edit',
    index: 'Index',
    keywordSearch: 'Please enter keyword',
    logout: 'Logout',
    logoutConfirm: 'Are you sure you want to log out?',
    lookForward: 'Coming soon',
    modify: 'Modify',
    modifySuccess: 'Modify Success',
    noData: 'No Data',
    operate: 'Operate',
    pleaseCheckValue: 'Please check whether the value is valid',
    refresh: 'Refresh',
    reset: 'Reset',
    search: 'Search',
    switch: 'Switch',
    tip: 'Tip',
    trigger: 'Trigger',
    update: 'Update',
    updateSuccess: 'Update Success',
    userCenter: 'User Center',
    companyMsg: 'Company Information',
    yesOrNo: {
      yes: 'Yes',
      no: 'No'
    },
    ensure: 'Ensure',
    back: 'Return',
    status: {
      enable: 'Enable',
      disable: 'Disable'
    },
    listNone: 'No data yet',
    delTitle: 'Confirm Delete',
    delStr: 'Are you sure you want to delete this {typeName}? This action cannot be undone.',
    confirmList:
      'Do you want to list the current resource version? After listing, users can use the current resource version',
    confirmUnList:
      'Do you want to remove the current resource version? After being taken down, users are unable to use the current resource version',
    download: 'Download',
    save: 'Save',
    submit: 'Submit',
    nextStep: 'Next step',
    online: 'Online',
    offline: 'Offline',
    upload: 'Upload files',
    settingSuccess: 'Set successful',
    haddleSuccess: 'Operation successful',
    uploadSuccess: 'Upload Successfully',
    uploadError: 'Upload failed',
    haddleError: 'Operation failed',
    langManage: 'Language management',
    current: 'Current',
    createStartTime: 'Create Start Time',
    createEndTime: 'Create End Time',
    view: 'View',
    input: 'Please enter',
    export: 'Export',
    import: 'Import',
    approve: 'Approve',
    pasteboardContent: 'Pasteboard Content',
    bulkCopy: 'Bulk Copy',
    uploadTimeout: "Upload timeout, please try again",
    uploadFailed: "Upload Failed",
  },
  base: {
    table: {
      updateTime: 'Update time'
    },
    form: {
      string2To50: 'Please enter a valid string of 2 to 50 characters. You are prohibited from entering <>',
      string2To100: 'Please enter a valid string of 2 to 100 characters. You are prohibited from entering <>',
      string2To200: 'Please enter a valid string of 2 to 200 characters. You are prohibited from entering <>',
      string0To200: 'Please enter a valid string of up to 200 characters. You are prohibited from entering <>',
      string0To500: 'Please enter a valid string of up to 500 characters. You are prohibited from entering <>',
      lettersNum0To50: 'Please enter up to 50 letters and numbers',
      invalidChars: 'Prohibited input {chars}',
      select: 'Please select'
    }
  },
  request: {
    logout: 'Logout user after request failed',
    logoutMsg: 'User status is invalid, please log in again',
    logoutWithModal: 'Pop up modal after request failed and then log out user',
    logoutWithModalMsg: 'User status is invalid, please log in again',
    refreshToken: 'The requested token has expired, refresh the token',
    tokenExpired: 'The requested token has expired'
  },
  route: {
    // '2_7': 'System Account',
    '2_8': 'Role Management',
    '2_9': 'Standard Category List',
    '2_10': 'Application Template List',
    '2_12': 'Menu Management',
    '3_13': 'Customer Management',

    '4_15': 'Product Development',
    '4_16': 'Device Management',
    '4_17': 'Firmware OTA',
    '4_18': 'Equipment debugging',
    '4_19': 'Device Log',
    '5_20': 'Application Development',
    '5_25': 'Account Reset',
    '6_23': 'Application Dashboard',
    '4_15_339': 'Product Details',
    '4_16_344': 'Device Details',
    '2_9_325': 'Standard Product Details',
    '3_13_336': 'Edit Customer',
    user: '',
    login: 'Login',
    403: 'No Permission',
    404: 'Page Not Found',
    500: 'Server Error',
    home: 'Home',
    exception: 'Exception',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500',
    system: 'System Management',
    system_account: 'Account Management',
    'system_application-template': 'Application template management',
    system_category: 'Standard category management',
    system_menu: 'Menu Management',
    system_firmwaretype: 'Product Firmware Type Configuration Management',
    'system_firmwaretype-lang': 'Multilingual Configuration of Firmware Types',
    system_role: 'Roles and permissions',
    application: 'Application Development and Operations',
    application_develop: 'Application Development',
    'application_protocal-manage': 'Protocol Management',
    'application_account-reset': 'Account reset',
    client: 'Customer management and operations',
    client_management: 'Customer Management',
    client_platform: 'Customer platform configuration',
    data: 'Data statistics and analysis',
    'data_all-screen': 'Data screen',
    'data_app-chart': 'Application dashboard',
    'data_product-chart': 'Product Dashboard',
    product: 'Product development and operation',
    product_debug: 'Equipment debugging',
    product_develop: 'Product Development',
    product_device: 'Device Management',
    product_firmware: 'Firmware OTA',
    'product_firmware-add': 'Create an OTA task',
    'product_firmware-list': 'OTA tasks',
    'product_firmware-task-detail': 'Equipment upgrade record',

    product_log: 'Device logs',

    'system_account-add': 'Add new account',
    'system_account-permission': 'Permission settings',
    'system_category-detail': 'Standard Category Details',
    'system_category-add': 'Create standard categories',
    'system_menu-lang': 'Menu multi-language',

    user_center: 'User Center',
    'user_reset-password': 'Reset Password',
    'user_reset-email': 'Reset Email',
    user_company: 'Company Information',

    'client_management-add': 'Create Customer',
    'client_management-edit': 'Edit Customer',

    'product_develop-add': 'Create a product',
    'product_develop-detail': 'Product Details',
    'product_device-detail': 'Equipment Details',
    'product_develop-lang': 'Product multi-language settings',

    'product_debug-add': 'Creating a Mock Device',
    'product_debug-detail': 'Mock device details',
    'application_application-version': 'Application Resource Management'
  },
  page: {
    login: {
      common: {
        loginOrRegister: 'Login',
        userNamePlaceholder: 'Please enter user name',
        phonePlaceholder: 'Please enter phone number',
        codePlaceholder: 'Please enter verification code',
        passwordPlaceholder: 'Please enter password',
        confirmPasswordPlaceholder: 'Please enter password again',
        codeLogin: 'Verification code login',
        confirm: 'Confirm',
        back: 'Back',
        validateSuccess: 'Verification passed',
        loginSuccess: 'Login successfully',
        welcomeBack: 'Welcome back, {userName} !',
        newPassword: 'New Password',
        passStep1: 'Password length 6-50 characters',
        passStep2: 'The password cannot contain spaces',
        passStep3: 'Password must contain letters and numbers',
        passStep4: 'The password cannot contain Chinese characters or Chinese symbols'
      },
      pwdLogin: {
        title: 'Password Login',
        rememberMe: 'Remember me',
        forgetPassword: 'Forget password?'
      },
      resetPwd: {
        title: 'Reset Password',
        getCode: 'Get verification code',
        reGetCode: 'Retrieve after {time} seconds',
        sendCodeSuccess: 'Verification code sent successfully',
        checkCodeSuccess: 'Verification code verification successful',
        checkCodeFail:
          'The verification code is wrong or expired. Please confirm whether the verification code is correct or obtain it again.',
        checkCodeNotFound: 'Please get the verification code first for verification',
        resetSuccess: 'Password reset successful'
      }
    },
    home: {
      welcome: 'Welcome',
      prod: 'Product Development',
      app: 'Application Development',
      data: 'Data Statistical Analysis',
      prodDesc: 'Unified management of product equipment and OTA upgrade',
      appDesc: 'Rapid application configuration and management',
      dataDesc: 'Get analytics data',
      more: 'Learn more',
      plan: 'Recommended Solution',
      hotPlan: 'Popular solutions',
      newPlan: 'Latest solutions',
      newProd: 'New Product News',
      message: 'Message Center',
      help: 'Help Center',
      showMore: 'See more'
    },
    category: {
      title: 'Standard category list',
      detail:
        'The table page is used to display multiple data with similar structures. The data can be sorted, filtered, compared or other customized operations can be performed on it.',
      icon: 'Standard product pictures',
      name: 'Standard category',
      namePlaceholder: 'Please enter the standard category',
      belongClass: 'Standard categories',
      belongClassPlace: 'Please select a standard category',
      vision: 'Current version',
      statement: 'state',
      statementPlace: 'Please select status',
      releaseStatus: 'Release Status',
      releaseStatusPlace: 'Please select the release status',
      createTs: 'Creation time',
      addCategory: 'Create standard categories',
      reaStatusList: {
        enable: 'Published',
        disable: 'Unpublished'
      },
      stateSuccess: 'The status of the standard category [{categoryName}] is switched to: {state}',
      detailBtn: 'Details',
      model: 'Configuration Function Model',
      addModelRes: 'Standard category created successfully',
      configTip: 'Please configure the function group and function point',
      configNone: 'Function groups and function points are not configured yet',
      addGroup: 'Adding functional groups',
      addGroupSuccess: 'Function group [{groupName}] added successfully',
      selectFun: 'Adding standard features',
      addFun: 'New standard features',
      functionName: 'Function Name',
      functionId: 'Function ID',
      functionType: 'Function Type',
      signCode: 'Sign Code',
      signCodeSum: 'Functional properties summary',
      swithcFun: 'Associate other feature IDs',
      funTip: 'Function Notes',
      setDefault: 'Set default functionality',
      modelFile: 'View model file',
      closeAll: 'Collapse all',
      openAll: 'Expand all',
      pickFun: 'Select standard features',
      pickedFun: 'Selected Features',
      clearFun: 'Clear all optional features',
      searchPlace: 'You can enter the product name, function point name, function point identification query',
      groupName: 'Functional Grouping',
      dataType: 'Data Types',
      readType: 'Read and write types',
      desc: 'describe',
      attributes: 'property',
      event: 'Event',
      server: 'Serve',
      status: 'Select Status',
      funNone: 'No function points yet',
      switchFunPlaceHolder: 'Please select the associated function point (multiple selections are allowed)',
      requiredList: {
        enable: 'default',
        disable: 'Cancel default'
      },
      requiredSuccess: 'Function {functionName} has been set to: {required}',
      readWrite: 'Read and Write',
      onlyRead: 'Read-only',
      onlyWrite: 'Write only',
      maxTip: 'The maximum value must be greater than the minimum value, please re-enter',
      minTip: 'The minimum value must be less than the maximum value, please re-enter',
      bite: 'byte',
      enum: 'Enumeration Values',
      addEnum: 'Adding Enumeration Values',
      arrayType: 'Element Type',
      jsonObj: 'Json Object',
      addParam: 'Add parameters',
      booleanVal: 'Boolean',
      jsonTitle: 'Json object parameters',
      addFunSuccess: 'Standard function [{functionName}] created successfully',
      selectFunSuccess: 'Standard function added successfully',
      inputLabel: 'Input Parameters',
      outputLabel: 'Output Parameters',
      info: 'information',
      call: 'notify',
      debug: 'Alerts',
      eventType: 'Event Type',
      editFun: 'Editing Standard Functions',
      updFunSuccess: 'Standard function [{functionName}] updated successfully',
      range: 'Numerical range',
      function: 'Standard Features',
      editGroup: 'Editing Function Groups',
      editGroupSuccess: 'Function group [{groupName}] updated successfully',
      fold: 'Close',
      unFold: 'Expand',
      listing: 'Available',
      delist: 'Removed',
      editBaseSuccess: 'Standard category updated successfully',
      listCheck: {
        title: 'Confirm listing',
        detail: 'Are you sure you want to list this standard category? This operation cannot be undone.',
        confirm: 'Available',
        success: 'Successfully launched'
      },
      unlistCheck: {
        title: 'Confirm removal',
        detail: 'Are you sure you want to remove this standard category? This operation cannot be undone.',
        confirm: 'Removed',
        success: 'Successfully removed from shelves'
      },
      exportFile: 'Export model file',
      jsonIntro:
        "The object model is a functional description of the device in the cloud, including the device's attributes, services, and events. The IoT platform describes the object model by defining a description language for objects, called TSL (Thing Specification Language), which uses the JSON format.",
      modelFileTitle: 'Model File',
      item: 'Standard category',
      relateFunSuccess: 'Linked features updated successfully',
      relateTip: 'The current function point has dependent function points, which are automatically checked for you',
      relateCancelTip: 'The current function point has dependent function points, which have been unchecked for you',
      sameSignCodeTip:
        'The current function point has a duplicate identifier with the selected function and cannot be selected',
      allSameTip: 'All selected functions are included in the function list. Please reselect the function you need.',
      filterSameTip:
        'Some of the selected features have duplicate identifiers ({codeStr}). The system has automatically filtered them for you.',
      mock: 'One-click mocking',
      multiLang: 'Multi-language settings'
    },
    account: {
      title: 'System Account',
      detail:
        'The table page is used to display multiple data with similar structures. The data can be sorted, filtered, compared or other customized operations can be performed on it.',
      nickname: 'User Nickname',
      name: 'User Account',
      accountValidity: 'Account validity period',
      createAccount: 'Create Account',
      createAccountLog: 'Create a system account',
      createAccountSuccess: 'Successfully created a system account',
      createAccountPullTitlle: 'Whether to sync accounts',
      createAccountPull:
        '{typeEmail} has been used by the account {typeName}. Do you confirm to synchronize this account to the current platform?',
      createAccountMsg: 'The specific account information has been sent to the corresponding email address',
      accountAuthorization: 'Go to account authorization',
      isResetPwd: 'Do you want to reset the current account password?',
      permissionSet: 'Permission settings',
      deleteAccountTip:
        'Do you want to reset and log out the current account? After logging out, the account information will be cleared',
      deleteAccount: 'Cancellation',
      accountPlaceholder: 'User name/User account/Email address',
      selectRoleType: 'Select the role type',
      customRole: 'Custom roles',
      menuPermissions: 'Menu Permissions',
      dataPermissions: 'Data permissions',
      selectProduct: 'Select your product',
      selectProductNum: '{products} products selected',
      allProduct: 'All Products',
      allProductSupport: '(including all products created afterwards)',
      selectApply: 'Select Application',
      selectApplyNum: '{applies} apps selected',
      allApply: 'All applications',
      allApplySupport: '(including all applications created afterwards)',
      noSetRole:
        'You have not set account permissions yet. Do you want to save the currently selected permission settings?',
      permissSuccess: 'Permissions set successfully',
      timeSwitch: '{start} to {end}',
      resetPwd: {
        title: 'Confirm Reset',
        detail:
          'Are you sure you want to reset the password for this account {typeName}? This operation cannot be undone.',
        confirm: 'Reset Password',
        success:
          'The password was reset successfully and the account and password information has been sent to the corresponding email address.'
      },
      cancelAcc: {
        title: 'Confirm cancellation',
        detail:
          'Are you sure you want to cancel the account {typeName}? After cancellation, the account information will be cleared, and this operation cannot be revoked.',
        confirm: 'Cancellation',
        success: 'Cancellation successful'
      },
      delAcc: {
        title: 'Confirm delete',
        detail:
          'Are you sure you want to delete the account {typeName}? After deletion, the account information will be cleared, and this operation cannot be revoked.',
        confirm: 'Delete',
        success: 'Delete successfully'
      },
      dateTip:
        'When creating an account, the validity period can be left blank by default. Leaving it blank means that the account is permanently valid.',
      foreverDate: 'Permanent'
    },
    role: {
      title: 'Role Management',
      detail:
        'The table page is used to display multiple data with similar structures. The data can be sorted, filtered, compared or other customized operations can be performed on it.',
      name: 'Role Name',
      deleteTip: 'Do you want to delete the current role?',
      createRole: 'Create a character',
      editRole: 'Edit Role',
      permissions: 'Role permissions',
      roleName: {
        label: 'Role Name',
        placeHolder: 'A valid string of 2 to 50 characters',
        required: 'The role name cannot be empty, please confirm the input',
        invalid: 'The role name format is incorrect'
      },
      createRoleTip: 'The number of characters has reached 30.',
      item: 'Role'
    },
    firmwareType: {
      add: 'Add Firmware Type',
      addVersion: 'Add Firmware Version',
      no: 'No.',
      maxLength:
        'The addition of firmware types has reached the upper limit! A maximum of 100 configurations are allowed.',
      lang: 'Multilingual Configuration of Firmware Types',
      remarkEn: 'Version Description (English)',
      lowVersion: 'Minimum Supported Version',
      dependency: 'Dependency Management (Optional)',
      chooseTip:
        'Please first select the firmware type corresponding to the newly added/edited firmware version, and then configure the dependencies.',
      saveSuccess: 'The firmware type configuration has been updated successfully!',
      minVersionRequired: 'The minimum supported version needs to be filled in completely. Please confirm the input.',
      firmwareTypeIdForm: {
        label: 'Firmware Type ID',
        required: 'The firmware type ID cannot be empty. Please confirm the input.',
        placeHolder: 'Please enter the firmware type ID'
      },
      firmwareTypeNameForm: {
        label: 'Firmware Type Name',
        required: 'The firmware type name cannot be empty. Please confirm the input.',
        placeHolder: 'Please enter the firmware type name'
      },
      multiType: 'Firmware Type - Version',
      multiTargetType: 'Firmware Type - Original Version Number - Target Version Number',
      clickTitle: 'Click to view',
      sameNoTip: 'The firmware type number cannot be repeated. Please confirm your input.',
      sameNameTip: 'The firmware type name cannot be repeated. Please confirm your input.',
      noneVersion: 'Not reported',
      sameTypeTip: 'The firmware types in the dependency configuration cannot be repeated. Please confirm your input.',
      minVerTip: 'The minimum supported version cannot be higher than or equal to the current firmware version number.',
      sameOtaVersion: 'The firmware types/versions cannot be repeated. Please confirm your input.'
    },
    multilingual: {
      title: 'Multilingual List',
      detail:
        'The table page is used to display multiple data with similar structures. The data can be sorted, filtered, compared or other customized operations can be performed on it.'
    },
    menu: {
      title: 'Menu Management',
      detail:
        'The table page is used to display multiple data with similar structures. The data can be sorted, filtered, compared or other customized operations can be performed on it.',
      addOneMenu: 'Add a first level menu',
      deleteTip:
        'Do you want to delete the current menu item? This will affect the page operation, please operate with caution!',
      setPerms: 'Set the permission flag',
      perms: {
        label: 'Permission identification',
        required: 'Permission identifier cannot be empty, please confirm input',
        placeHolder: 'Please enter the permission identifier'
      },
      oneMenu: 'First level menu',
      twoMenu: 'Secondary Menu',
      threeMenu: 'Third level menu',
      menuName: 'Menu name',
      menuPlaceholder: 'Please enter the menu name',
      menuNameForm: {
        label: 'Menu name',
        required: 'Menu name cannot be empty, please confirm input',
        invalid: 'The menu name format is incorrect',
        placeHolder: 'Please enter the menu name'
      },
      menuLang: 'Menu multilingual settings'
    },
    menuLang: {
      belongMenu: 'Belonging menu',
      edit: 'Modify the Copywriter',
      code: 'Entry code'
    },
    client: {
      title: 'Customer Management',
      detail:
        'The table page is used to display multiple structurally similar data, which can be sorted, filtered, compared, or other customized operations.',
      dateCenter: 'Data center list retrieval failed',
      base: 'Basic Information',
      admin: 'Customer Super System Administrator Information',
      updateAdmin: 'Administrator information updated successfully',
      namePlaceholder: 'Tenant UUID/Customer Full Name/Customer Unified Social Credit Code/Customer Domain Name',
      create: 'Create Customer',
      uuid: 'Customer UUID',
      id: 'Customer ID',
      status: 'Enable status',
      stateSuccess: "The client's status has been switched to {state}",
      deleteTip: 'Do you want to delete the current customer',
      startStauts:
        'After the customer enables it, all applications、\n devices under the customer will be restored to use',
      disableUserValidate: 'Disable customer verification',
      disableUserTip:
        'After the customer disables it, all applications and devices under the customer cannot be used. Please operate with caution!',
      disableUser: 'Disable customers',
      item: 'customer',
      oem: 'OEM configuration',
      reset: 'Restore Default'
    },
    devices: {
      selectProduct: 'Product',
      selectCategory: 'Category',
      selectStatus: 'State',
      selectDataCenter: 'Data center',
      namePlaceholder: 'Device ID/MAC address',
      inputNamePlaceholder: 'Please enter device ID/MAC address',
      deviceProduct: 'Device associated product name:',
      deviceId: 'Device ID',
      deviceName: 'Device Name',
      productName: 'Belonging products',
      productId: 'Product ID',
      mac: 'MAC Address',
      online: 'Online status',
      lastOnlineTime: 'Last online time',
      lastOfflineTime: 'Last offline time',
      log: 'Log',
      record: 'Record',
      functionType: 'Function type',
      functionId: 'Function ID',
      messageId: 'MessageId',
      flow: 'Data sources ',
      dataDetail: 'Data Details',
      messageTimestamp: 'Trigger time',
      deviceMsg: 'Device information',
      deviceLog: 'Device online and offline records',
      deviceOffline: 'Device offline log',
      beProduct: 'Belonging products',
      deviceMac: 'Device MAC',
      deviceCategory: 'Category',
      deviceVersion: 'Device firmware version',
      systemVersion: 'Equipment system version',
      deviceMCU: 'Device MCU version',
      deviceNetwork: 'Device network information',
      deviceArea: 'Region to which the device belongs',
      inputSearchTip: 'Please enter the device ID/MAC address first',
      tipEnterTip: 'Press Enter to search for the device log list',
      minVersion: 'Minimum version',
      maxVersion: 'Maximum version'
    },
    deviceLog: {
      title: 'Device logs',
      detail:
        'The table page is used to display multiple structurally similar data, which can be sorted, filtered, compared, or other customized operations.',
      timeTip:
        'Currently supports querying device log data for 7 days. If you want to query more data, please contact Business to activate the service',
      contact: 'Contact email:',
      deviceFlow: 'Device end',
      iCloudFlow: 'Cloud',
      customCode: 'User-defined Identifier ',
      systemCode: 'System Identifier'
    },
    deviceOffline: {
      logName: 'Log name',
      createTime: 'Create time',
      updateTime: 'Update time',
      downloadSuccess: 'Download successful'
    },
    product: {
      title: 'Product List',
      detail:
        'The table page is used to display multiple structurally similar data, which can be sorted, filtered, compared, or other customized operations.',
      productName: 'Product name',
      productId: 'ProductId ID',
      pic: 'Product images',
      productType: 'Standard Category',
      productClass: 'Product Category',
      protocol: 'Communication method',
      status: 'Development status',
      addProduct: 'Create product',
      searchName: 'Product Name/Product Id',
      productTypePlace: 'Please select the standard category',
      productClassPlace: 'Please select product category',
      item: 'Product',
      wifi: 'WIFI',
      knx: 'KNX',
      zigbee: 'Zigbee',
      ethernet: 'Ethernet',
      honey: 'Honeycomb',
      blue: 'Bluetooth',
      stepSelect: 'Select standard category',
      stepSelectTip: 'Standard category as template basis',
      stepSet: 'Product information customization settings',
      stepSetTip: 'Set product information based on standard category templates',
      searchCate: 'Standard category name query',
      allClass: 'All standard categories',
      categoryNone: 'There are currently no standard categories under this category',
      next: 'Next step',
      choose: 'Next Step (Standard Category Selected: {categoryName})',
      monomer: 'Monomer',
      gateway: 'Gateway',
      gatewaySub: 'Internet gateway sub device',
      backChoose: 'Selected standard category: {categoryName}',
      back: 'Reselect',
      addProdRes: 'Product creation successful',
      info: 'Product Information',
      model: 'Product Function Model',
      config: 'Product Configuration',
      firmVision: 'Firmware version',
      cateName: 'Belonging to the standard category',
      editBaseSuccess: 'Product information updated successfully',
      updFunSuccess: 'The product function [{functionName}] has been successfully updated',
      addFunSuccess: 'Product function [{functionName}] created successfully',
      function: 'Product Features',
      editFun: 'Edit product features',
      addFun: 'Add custom features',
      loRaWAN: 'LoRaWAN',
      listCheck: {
        title: 'Confirm listing',
        detail: 'Are you sure you want to list this product? This operation cannot be undone.',
        confirm: 'Grounding',
        success: 'Shelf success'
      },
      unlistCheck: {
        title: 'Confirm removal',
        detail: 'Are you sure you want to remove this product? This operation cannot be undone.',
        confirm: 'UnShelve',
        success: 'Removed successfully'
      },
      scene: 'Application scenarios',
      toConfig: 'configuration',
      configRes: 'Application scenario configuration successful',
      configTitle: 'Configure application scenarios',
      appId: 'Application ID',
      appName: 'Application Name',
      appNone: 'Application scenario not yet configured',
      firmwareTypePlace: 'Please select firmware type',
      firmwareUpdPlace: 'Please select the firmware upgrade method',
      firmwareStatusPlace: 'Please select firmware version status',
      versionNumberPlace: 'Version',
      other: 'Other',
      firmwareOption: {
        mcu: 'MCU firmware',
        system: 'FirmWare',
        software: 'Software firmware',
        other: 'Other'
      },
      firmwareUpd: {
        notice: 'Reminder to upgrade',
        force: 'Force Upgrade',
        check: 'Detection upgrade'
      },
      firmwareNone: 'No firmware version available at the moment',
      firmwareColumns: {
        name: 'Firmware version name',
        vision: 'Firmware Version',
        file: 'Firmware file',
        type: 'Firmware type',
        timeout: 'Firmware upgrade timeout',
        upd: 'Firmware upgrade method',
        status: 'Version Status',
        tip: 'Version description',
        disabled: 'Stop taking down',
        listing: 'Grounding',
        add: 'Add firmware version',
        edit: 'Edit firmware version',
        check: 'Check firmware version',
        min: 'minute',
        item: 'firmware'
      },
      firmwareList: 'Released firmware version',
      disableTitle: 'Withdraw firmware version',
      firmwareAlert:
        'Going live is mainly used to control whether the current firmware version is available for firmware upgrade. ',
      firmwareConfirm: 'Firmware Information Confirmation',
      firmwareRange: 'Configure the allowed usage range',
      noRange: 'Unrestricted in scope',
      limitRange: 'Limit the scope',
      limitTitle: 'The authorized scope',
      limitNoneTip: 'The authorized scope cannot be empty. Please select a device.',
      editLimit: 'Modify the authorized scope',
      addLimit: 'add',
      limitAlert:
        'Only the devices within the authorized scope are supported to use this firmware version for firmware upgrading. ',
      configNone: 'No application scenario data available for configuration at the moment',
      configListTitle: 'List of configured application scenarios',
      devSameTip: 'There are duplicate devices selected. Please re-enter. ',
      addFirmwareSuccess: 'Firmware version [{updateName}] created successfully',
      editFirmwareSuccess: 'Firmware version [{updateName}] updated successfully',
      enableStatusSuccess: 'The firmware version status of [{updateName}] has been updated to: Released',
      disableStatusSuccess: 'The firmware version status of [{updateName}] has been updated to: taken down',
      firmwareStatus: {
        listing: 'Grounding',
        delist: 'Not listed yet'
      },
      selectFunSuccess: 'Product function added successfully',
      file: 'File Upload',
      fileMd5: 'File Parsing...',
      info1: '1. Please be patient when uploading large files.',
      info2:
        '2. If you close the popup while uploading a file, the current firmware file will be cleared, but the upload progress will be saved.',
      info3: '3. Uploading the firmware for the second time will overwrite the old firmware file.',
      chooseFile: 'Choose File',
      sceneTitle: 'Automation Scene Settings',
      sceneCondition: 'Scene Trigger Condition Settings',
      sceneMission: 'Scene Execution Task Settings',
      conditionTip:
        'After setting the scene trigger conditions, this feature will appear in App > Smart Scenes > New Scene > Add Condition, to be set as the trigger condition for the scene.',
      missionTip:
        'After setting the scene execution conditions, this feature will appear in App > Smart Scenes > New Scene > Add Task, to be set as the execution condition for the scene.',
      closeTitle: 'Close Prompt',
      closeStr: 'Are you sure you want to close the popup and interrupt the file upload?',
      fileNoneFinish: 'File upload not completed, please be patient.',
      subDevice: 'View sub devices',
      gatewayDevice: 'View gateway sub devices',
      sceneTip:
        'User-defined set whether function points support trigger conditions and execute tasks in intelligent scenarios. After you select Support, users can set corresponding functions in App intelligent scenarios.',
      sceneRes: 'The automatic scenario is set successfully',
      copy: 'One-click Copy',
      copyTitle: 'One-click Copy Product',
      chooseClient: {
        label: 'Select Client',
        required: 'The selected client cannot be empty. Please confirm the input.',
        placeHolder: 'Please select a client'
      },
      copyAlert:
        'After confirming to copy "{product}", a new product will be automatically created. The new product is in an unpublished state by default.',
      copyAble: 'Copying is supported.',
      copyDisable: 'Copying is not supported.',
      copySuccess: 'Copying succeeded!',
      copyProdName: 'Copy-',
      functionQuickImport: 'Quick Import',
      functionQuickImportTip: 'Please enter the json content that meets the requirements',
      functionQuickImportSuccess: 'Quick import successful!'
    },
    company: {
      name: {
        label: 'Full name',
        required: 'Full name cannot be empty, please confirm input',
        invalid: 'Please enter 2~50 valid characters, do not enter<>',
        placeHolder: 'A valid string of 2 to 50 digits'
      },
      abbrName: {
        label: 'Abbreviation',
        required: 'Abbreviation cannot be empty, please confirm input',
        invalid: 'Please enter 2~50 valid characters, do not enter<>',
        placeHolder: 'A valid string of 2 to 50 digits'
      },
      country: {
        label: 'Area',
        required: 'The location cannot be empty, please confirm the input',
        invalid: 'The format of the region is incorrect',
        placeHolder: 'A valid string of 2-200 bits'
      },
      domainName: {
        label: 'domain name',
        required: 'Domain name cannot be empty, please confirm input',
        invalid:
          'Please enter the domain name in the correct format, allowing English, numbers, and symbols- combination',
        placeHolder: 'Domain Name Format'
      },
      recordNumber: {
        label: 'Record number',
        required: 'Record number cannot be empty, please confirm input',
        invalid: 'The format of the filing number is incorrect',
        placeHolder: 'A valid string of 2 to 50 digits'
      },
      logo: {
        label: 'logo',
        invalid:
          'Please provide an icon with a size of 180x48 pixels, in PNG format, and a file size not exceeding 3M.',
        placeHolder: 'Click to upload image',
        required: 'Please upload pictures'
      },
      systemName: {
        label: 'System name',
        required: 'System name cannot be empty, please confirm input',
        invalid: 'The system name format is incorrect',
        placeHolder: 'A valid string of 2-200 bits'
      }
    },
    userCenter: {
      base: 'Basic information',
      accountName: 'User account',
      sex: 'User gender',
      login: 'login information',
      password: 'Login password',
      passwordTip: 'We suggest that you change your password regularly to ensure account security',
      changePassword: 'Change Password',
      bindEmail: 'Bind email',
      bindedEmail: 'You have bound an email address: {email}',
      editEmail: 'Change email address',
      resetBind: 'Rebind',
      sendCode: 'Send verification code',
      finish: 'Complete',
      male: 'male',
      female: 'female',
      noSelectSex: 'Gender not yet selected',
      updatePswSuccess: 'Password reset successful',
      reconfirm: 'Log in again',
      resetEamilTip:
        'Congratulations, the submission was successful. \n The new email account has been successfully bound',
      noSelectIcon: 'Please complete the avatar information',
      logoPic: 'Please provide a user profile picture in JPG, PNG, JPEG format, with a file size not exceeding 3M.',
      noConfigSever: 'No data center configuration available at the moment'
    },
    firmware: {
      createOTA: 'Create product OTA',
      view: 'view',
      otaTask: 'OTA task',
      viewAllOTA: 'View all OTA tasks',
      allClose: 'close all',
      taskName: {
        label: 'TASK',
        placeHolder: 'A valid string of 2 to 50 digits',
        required: 'Task name cannot be empty, please confirm input',
        invalid: ''
      },
      taskRankAbbr: 'priority',
      taskRank: {
        label: 'task priority',
        placeHolder: 'Please select task priority',
        required: 'Task priority cannot be empty, please confirm input',
        invalid: ''
      },
      taskMsg: {
        label: 'Upgrade copy',
        placeHolder: 'Valid string of 2~200 characters',
        required: 'Upgrade copy cannot be empty, please confirm your input',
        invalid: ''
      },
      taskType: {
        label: 'Upgrade Strategy',
        placeHolder: 'Please select an upgrade strategy',
        required: 'Upgrade strategy cannot be empty, please confirm your input',
        invalid: ''
      },
      taskStartTime: 'Start Upgrade Time',
      taskTime: 'Upgrade Time',
      executeNow: 'Execute Immediately?',
      firmwareType: {
        label: 'Firmware Type',
        placeHolder: 'Please select a firmware type',
        required: 'Firmware type cannot be empty, please confirm your input',
        invalid: ''
      },
      deviceNums: 'Device Quantity',
      rate: 'Completion Rate',
      rate1: 'Completion Level',
      selectFirmwareVersion: {
        label: 'Firmware Version',
        placeHolder: 'Please select a firmware version',
        required: 'Firmware version cannot be empty, please confirm your input',
        invalid: ''
      },
      selectDevices: 'Select Devices',
      upgradePolicy: 'Configure Upgrade Strategy',
      commonProduct: 'Common Products',
      productIDPlaceholder: 'Please enter product ID to search for product information',
      productDetail: 'Product Details',
      productOTATask: 'All OTA Tasks of',
      updatingNums: 'Upgrading: {number} devices',
      selectUpdatingDevices: 'Select Upgrade Devices',
      selectXDevices: '(Selected {number} devices)',
      totalSelectDevices: 'Total {number} devices',
      pollTask: 'Polling Task',
      onceTask: 'Single Task',
      startTime: 'Start Time',
      endTime: 'End Time',
      noProduct: 'No product information available',
      changeProductTip: 'Switch products?\nConfirming will reset configuration information',
      inputProduct: 'Please enter product ID',
      resetTask: 'Confirming will reset configuration information',
      taskSearchInput: 'Task Name',
      taskStauts: 'Task Status',
      firmwareOtaStatus: {
        0: 'Not Started',
        1: 'Waiting for Next Execution',
        2: 'In Progress',
        3: 'Paused',
        4: 'Ended',
        5: 'Cancelled'
      },
      otaResultStatus: {
        0: 'Not Started',
        1: 'Waiting',
        2: 'Upgrading',
        3: 'Upgrade Successful',
        4: 'Upgrade Failed'
      },
      taskId: 'Task ID',
      srcVersionNumber: 'Source Version Number',
      targetVersionNumber: 'Target Version Number',
      updatedResult: 'Upgrade Result',
      schedule: 'Progress Status',
      haddleName: 'Operator',
      retryUpdate: 'Retry Batch Upgrade',
      updateAtOnce: 'Upgrade Now',
      noSchedStatus: 'No progress status available',
      overTime: 'Timeout Failed',
      overLevel: 'Higher priority execution caused the current task to fail',
      sedFail1: 'Upgrade file download failed',
      sedFail2: 'Upgrade file verification failed',
      sedFail3: 'Upgrade file installation failed',
      showRate: 'View Progress Status',
      secondStatus: {
        title1: 'Received',
        title2: 'Downloading',
        title3: 'Verifying',
        title4: 'Installing',
        title5: 'Restarting',
        content1: 'Device received OTA request',
        content2: 'Download progress: {finishNum}%',
        content3: 'Verifying upgrade file',
        content4: 'Installing upgrade file',
        content5: 'Device is restarting',
        taskSchedStatus: 'Task Progress Status'
      },
      detail: 'Upgrade Records',
      pause: 'Pause',
      play: 'Start',
      restart: 'Restart Upgrade',
      cancel: 'Cancel Upgrade',
      playTip: 'Task 【{taskName}】 is starting the upgrade!',
      pauseTip: 'Task 【{taskName}】 is paused!',
      restartTip: 'Task 【{taskName}】 is restarting the upgrade!',
      cancelTip: 'Task 【{taskName}】 has been canceled!',
      batchForceUpgrade: 'Batch Force Upgrade ({number} devices)',
      batchForceUpgradeTip: 'Are you sure you want to enable forced upgrade for {number} devices with upgrade risks?',
      batchForceUpgradeSuccess: 'Forced upgrade enabled for {number} devices',
      confirmUpgradeTip: 'The device has upgrade risk, please manually confirm the upgrade',
      riskDeviceCount: 'Upgrade risk {number} devices',
      confirmedRiskDeviceCount: 'Confirmed {number} devices',
      selectLimitMsg: 'Limit reached. To replace, please deselect a device first.',
      selectedCount: 'Selected',
      deviceUnit: 'devices',
      maxSelectWarning: 'You can select up to {maxCount} devices. Only the first {maxCount} have been kept.',
      maxSelectReached: 'The maximum number of selectable devices ({maxCount}) has been reached.'
    },
    mock: {
      title: 'Product Mock List',
      detail:
        'The table page is used to display multiple data entries with similar structures, allowing for sorting, filtering, comparison, or other custom operations.',
      searchPlace: 'Device Mock Name/Mock ID/Product ID',
      addCode: 'Generate QR Code',
      addMock: 'Create Mock Device',
      addMockSuccess: 'Mock device created successfully!',
      deviceName: 'Mock Name',
      deviceNamePlaceHolder: 'Please enter Mock name',
      deviceId: 'Mock ID',
      belongClass: 'Belongs to Product',
      item: 'Mock Device',
      searchResult: 'No product information found, please confirm your input',
      searchResultErr: 'Please select a standalone or gateway type product',
      clearProdId: {
        detail:
          'You have mounted child devices. Changing the product will clear the mounted data. Do you want to continue?',
        confirm: 'Continue'
      },
      childDev: 'Mount Child Device',
      selectChildDev: 'Add Child Device',
      searchChildDev: 'Please select a child device for control',
      popTip1: '1. Only standalone or gateway child devices can be mounted',
      popTip2:
        '2. Maximum of 10 devices can be mounted. If the actual number exceeds 10, create a new device mock for debugging',
      devChildColumn: {
        id: 'Child Device ID',
        child: 'Child Device Name',
        add: 'Add Quantity'
      },
      selectLimit: 'The selected product quantity has exceeded the limit!',
      searchFlagTip: 'Please first search to check if the entered product ID exists',
      subDev: 'Mount Child Device',
      control: 'Control Panel',
      deviceType: {
        all: 'All',
        config: 'Attributes',
        event: 'Events',
        server: 'Services',
        systemEvent: 'System Events',
        systemServer: 'System Services'
      },
      reset: 'One-Click Initialization',
      allSend: 'One-Click Send',
      controlColumn: {
        id: 'Function ID',
        name: 'Function Name - Identifier - Function ID',
        value: 'Parameter Value',
        send: 'Send',
        init: 'Initialize',
        setDefVal: 'Set Default Value'
      },
      realTimeLog: 'Real-Time Log',
      keywordPlace: 'Please enter a keyword and press Enter to search',
      clearLog: 'Clear Log',
      realLogColumn: {
        dataFlow: 'Data Flow',
        message: 'Message Type',
        date: 'Date Time',
        info: 'Content',
        call: 'Request',
        back: 'Response'
      },
      devLogin: 'Device Login',
      devCerti: 'Device Identity Information',
      devLogUpdate: 'Device Real-Time Log Reporting',
      tou: 'Transparent Transmission',
      token: 'Token Refresh',
      syncDev: 'Device Information Sync',
      mqConnectSuc: 'MQTT Connection Successful!',
      mqConnectFail: 'MQTT Connection Failed!',
      subscribeFail: 'MQTT Subscription Failed!',
      subscribeSuc: 'MQTT Topic Subscription Successful!',
      loginTitle: 'Device Login Failed',
      loginStr: 'Device Login Response Content:',
      reLogin: 'Re-login',
      loginSuc: 'Device Login Successful',
      editDevName: 'Modify Mock Device Name',
      copyTip: 'Copy Successful!',
      copyDisabled: 'Your browser does not support copying',
      setDef: 'Set Default Value',
      condition: 'When {funName} is',
      todoTip: 'Linkage Settings:',
      valuePlace: 'Please enter parameter value',
      addPreset: 'Add New Preset Value',
      presetFunPlace: 'Please select preset function',
      addPresetMax: 'A maximum of 20 function points can be linked',
      addPresetSuccess: 'Preset value set successfully!',
      static: 'Static Code'
    },
    data: {
      title: 'Data Board',
      systemTitle: 'System data',
      deviceRankingList: 'Top 10 products by number of devices.',
      useProductRankingList: 'Top 10 most-used products',
      useFunctionRankingList: 'Top 10 most-used product features',
      appNums: 'Apps',
      appUnit: 'unit',
      productNums: 'Products',
      productUnit: ' ',
      devicesNums: 'Devices',
      devicesUnit: '',
      logNums: 'EQP news',
      logUnit: '',
      newsNums: 'CMD',
      newsUnit: '',
      realTimeNums: 'RODC',
      useTime: 'Usage times',
      areaEurope: 'Europe',
      areaTheMiddleEast: 'Middle East',
      chinaDevicesDistribution: 'Device distribution in China',
      europeDevicesDistribution: 'Device distribution in Europe',
      middleEastDevicesDistribution: 'Device distribution in the Middle East',
      statisticsDate: 'Data cut-off time : ',
      serveChina: 'China data center',
      serveEurope: 'Europe data center',
      serveArabia: 'Arabia data center',
      myriad: '10K',
      million: 'M',
      allDevices: 'Devices',
      productDevices: 'Devices : ',
      productUses: 'Usage times : ',
      startCarousel: 'Start carousel',
      stopCarousel: 'Stop carousel',
      deviceNums: 'EQP Numbers',

      // 中国
      beijing: 'Beijing',
      tianjin: 'Tianjin',
      hebei: 'Hebei',
      shanxi: 'Shanxi',
      neimenggu: 'Neimenggu',
      liaoning: 'Liaoning',
      jilin: 'Jilin',
      heilongjiang: 'Heilongjiang',
      shanghai: 'Shanghai',
      jiangsu: 'Jiangsu',
      zhejiang: 'Zhejiang',
      anhui: 'Anhui',
      fujian: 'Fujian',
      jiangxi: 'Jiangxi',
      shandong: 'Shandong',
      henan: 'Henan',
      hubei: 'Hubei',
      hunan: 'Hunan',
      guangdong: 'Guangdong',
      guangxi: 'Guangxi',
      hainan: 'Hainan',
      chongqing: 'Chongqing',
      sichuan: 'Sichuan',
      guizhou: 'Guizhou',
      yunnan: 'Yunnan',
      xizang: 'Xizang',
      gansu: 'Gansu',
      ningxia: 'Ningxia',
      xinjiang: 'Xinjiang',
      qinghai: 'Qinghai',
      taiwan: 'Taiwan',
      xianggang: 'Hong Kong',
      aomen: 'Macao',
      // 欧洲
      england: 'England',
      ukraine: 'Ukraine',
      switzerland: 'Switzerland',
      sweden: 'Sweden',
      spain: 'Spain',
      slovakia: 'Slovakia',
      slovenia: 'Slovenia',
      serbia: 'Serbia',
      sanmarino: 'Sanmarino',
      romania: 'Romania',
      portugal: 'Portugal',
      poland: 'Poland',
      norway: 'Norway',
      netherlands: 'Netherlands',
      moldova: 'Moldova',
      malta: 'Malta',
      macedonia: 'Macedonia',
      luxembourg: 'Luxembourg',
      latvia: 'Latvia',
      liechtenstein: 'Liechtenstein',
      lithuania: 'Lithuania',
      italy: 'Italy',
      ireland: 'Ireland',
      iceland: 'Iceland',
      hungary: 'Hungary',
      greece: 'Greece',
      germany: 'Germany',
      france: 'France',
      finland: 'Finland',
      estonia: 'Estonia',
      denmark: 'Denmark',
      czech: 'Czech',
      croatia: 'Croatia',
      bulgaria: 'Bulgaria',
      bosnia: 'Bosnia',
      belgium: 'Belgium',
      belarus: 'Belarus',
      austria: 'Austria',
      albania: 'Albania',
      russia: 'Russia',

      // 中东
      yemen: 'Yemen',
      united_arab_emirates: 'United Arab Emirates',
      turkey: 'Turkey',
      tunisia: 'Tunisia',
      syria: 'Syria',
      saudi_arabia: 'Saudi Arabia',
      qatar: 'Qatar',
      oman: 'Oman',
      morocco: 'Morocco',
      libya: 'Libya',
      lebanon: 'Lebanon',
      kuwait: 'Kuwait',
      jordan: 'Jordan',
      israel: 'Israel',
      palestine: 'Palestine',
      iraq: 'Iraq',
      iran: 'Iran',
      egypt: 'Egypt',
      cyprus: 'Cyprus',
      bahrain: 'Bahrain',
      algeria: 'Algeria'
    },
    develop: {
      account: 'Account',
      nickname: 'Nickname',
      phone: 'Phone',
      email: 'Email',
      appName: 'App Name',
      tenantName: 'Tenant Name',
      isOwner: 'Is Owner',
      createTime: 'Create Time',
      validTime: 'Valid Time',
      avatar: 'Avatar',
      resetPassword: 'Reset Password',
      phonePlaceholder: 'Please enter phone number or email address',
      resetPasswordConfirm: 'Are you sure you want to reset the account password?',
      copyPassword: 'Copy Password',
      copyPasswordSuccess: 'Copy successful',
      copyPasswordFail: 'Copy failed'
    },
    appSolution: {
      msgType: 'Message Type',
      fieldKey: 'Field Key',
      fieldDesc: 'Field Description',
      purpose: 'Purpose',
      scene: 'Scene',
      showContent: 'Show Collection Content',
      dataMasking: 'Data Masking',
      isDesensitize: 'Is Data Masked',
      dataMaskingRule: 'Data Masking Rule',
      exportTitle: 'Export Personal Information Configuration',
      exportStr: 'Do you want to export the personal information configuration?',
      personalInfoConfig: 'Personal Information Configuration',
      addPersonalInfo: 'Add Personal Information Field',
      editPersonalInfo: 'Edit Personal Information Field',
      prefix: 'Prefix Digits to Preserve',
      suffix: 'Suffix Digits to Preserve',
      replaceContent: 'Replacement Content',
      dataMaskingRuleTip:
        'Keep the first {prefix} digits, replace the middle with {replaceContent}, keep the last {suffix} digits',
      importJsonError: 'Failed to parse JSON file',
      importJsonError2: 'Error in field {field} at array item {index}',
      msgTypeOptions: {
        1: 'User Profile Information',
        2: 'User Identity Information',
        3: 'User Face Information',
        4: 'User Service Content Information',
        5: 'Device Information'
      },
      commonI18nKey: {
        application_template_name: 'Application Solution Name',
        application_template_sms_sign: 'SMS Signature',
        application_template_sms_code: 'SMS Template Code',
        application_template_email_subject: 'Email Subject',
        application_template_email_content: 'Email Template',
        application_name: 'Application Name',
        application_sms_sign: 'SMS Signature',
        application_sms_code: 'SMS Template Code',
        application_email_subject: 'Email Subject',
        application_email_content: 'Email Template'
      }
    },
    i18nSettings: {
      applicationName: 'Application Name',
      smsTemplate: 'SMS Template',
      emailTemplate: 'Email Template',
      personalInfo: 'Personal Information',
      fieldName: 'Field Name',
      versionResourceDesc: 'Version Resource Description',
      resourceType: 'Resource Type',
      versionCode: 'Version Code'
    }
  },
  form: {
    required: 'Cannot be empty',
    userName: {
      required: 'Please enter user name',
      invalid: 'User name format is incorrect',
      placeHolder: 'Please enter user account/email'
    },
    phone: {
      required: 'Please enter phone number',
      invalid: 'Phone number format is incorrect',
      placeHolder: 'Please enter user account/email'
    },
    pwd: {
      label: 'Password',
      required: 'Please enter password',
      invalid: 'Password format is incorrect; 6-50 characters, must include letters and numbers',
      placeHolder: 'Please enter password'
    },
    confirmPwd: {
      label: 'Confirm New Password',
      required: 'Please enter password again',
      invalid: 'The two passwords are inconsistent',
      placeHolder: 'Please enter user account/email'
    },
    code: {
      label: 'Verification Code',
      required: 'Please enter verification code',
      invalid: 'Verification code format is incorrect',
      placeHolder: 'Please enter verification code'
    },
    email: {
      label: 'Email',
      required: 'Please enter email',
      invalid: 'Email format is incorrect',
      placeHolder: 'Email format'
    },
    account: {
      label: 'Account',
      required: 'Please enter user account or email',
      invalid: 'Account format is incorrect',
      placeHolder: 'Please enter user account or email'
    },
    // 标准品
    categoryName: {
      required: 'Name cannot be empty, please confirm your input',
      invalid: 'Please enter 2~50 valid characters; < > are not allowed',
      placeHolder: 'Valid string of 2~50 characters',
      label: 'Name'
    },
    classId: {
      required: 'Standard category cannot be empty, please confirm your input',
      placeHolder: 'Please select a standard category',
      label: 'Standard Category'
    },
    categoryPic: {
      label: 'Category Image',
      invalid:
        'Please provide a category icon: size 168x168 pixels, PNG format, transparent background, file size not exceeding 100KB.',
      placeHolder: 'Click to upload image',
      required: 'Please upload category image'
    },
    categoryDesc: {
      label: 'Category Description',
      placeHolder: 'Valid string of 1~200 characters'
    },
    groupName: {
      label: 'Function Group Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Function group name cannot be empty, please confirm your input',
      invalid: 'Function group name format is incorrect'
    },
    functionName: {
      label: 'Function Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Function name cannot be empty, please confirm your input',
      invalid: 'Please enter 2~50 valid characters; < > are not allowed'
    },
    signCode: {
      label: 'Identifier',
      placeHolder: 'Valid string of 2~50 characters; English letters, numbers, and _ . are allowed',
      required: 'Identifier cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 2~50 characters; English letters, numbers, and _ . are allowed'
    },
    description: {
      label: 'Description',
      placeHolder: 'Valid string of 1~200 characters',
      invalid: 'Please enter a valid string of 1~200 characters; < > are not allowed'
    },
    max: {
      label: 'Maximum Value',
      placeHolder: 'Integer of 1~15 digits',
      required: 'Maximum value cannot be empty, please confirm your input',
      invalid: 'Please enter an integer of 1~15 digits'
    },
    min: {
      label: 'Minimum Value',
      placeHolder: 'Integer of 1~15 digits',
      required: 'Minimum value cannot be empty, please confirm your input',
      invalid: 'Please enter an integer of 1~15 digits'
    },
    maxDouble: {
      label: 'Maximum Value',
      placeHolder: 'Enter a decimal, with up to three decimal places',
      required: 'Maximum value cannot be empty, please confirm your input',
      invalid: 'Please enter a decimal, with up to three decimal places'
    },
    minDouble: {
      label: 'Minimum Value',
      placeHolder: 'Enter a decimal, with up to three decimal places',
      required: 'Minimum value cannot be empty, please confirm your input',
      invalid: 'Please enter a decimal, with up to three decimal places'
    },
    stepDouble: {
      label: 'Step',
      placeHolder: 'Enter a decimal, with up to three decimal places',
      required: 'Step cannot be empty, please confirm your input',
      invalid: 'Please enter a decimal, with up to three decimal places'
    },
    step: {
      label: 'Step',
      placeHolder: 'Integer of 1~15 digits',
      required: 'Step cannot be empty, please confirm your input',
      invalid: 'Please enter an integer of 1~15 digits'
    },
    unit: {
      label: 'Unit',
      placeHolder: 'Please select a unit'
    },
    length: {
      label: 'Data Length',
      placeHolder: 'Input range: 1~2147483647',
      required: 'Data length cannot be empty, please confirm your input',
      invalid: 'Please enter a value within the range of 1~2147483647'
    },
    enumKey: {
      label: 'Parameter Value',
      placeHolder: '1~10 digits or letters',
      required: 'Parameter value cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 1~10 characters; letters and numbers are allowed'
    },
    enumVal: {
      label: 'Parameter Description',
      placeHolder: 'Valid string of 1~50 characters',
      required: 'Parameter description cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 1~50 characters; < > are not allowed'
    },
    arraySize: {
      label: 'Number of Elements',
      placeHolder: 'Input range: 1~2147483647',
      required: 'Number of elements cannot be empty, please confirm your input',
      invalid: 'Please enter a value within the range of 1~2147483647'
    },
    booleanDesc: {
      placeHolder: 'Valid string of 1~50 characters',
      required: 'Boolean value cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 1~50 characters; < > are not allowed'
    },
    paramName: {
      label: 'Parameter Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Parameter name cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 2~50 characters; < > are not allowed'
    },
    version: {
      label: 'Current Version',
      placeHolder: 'No historical versions available'
    },
    nodeType: {
      label: 'Node Type',
      placeHolder: 'Please select a node type',
      required: 'Node type cannot be empty, please confirm your input',
      invalid: 'Node type format is incorrect'
    },
    productPic: {
      label: 'Product Image',
      invalid:
        'Please provide a product icon: size 168x168 pixels, PNG format, transparent background, file size not exceeding 100KB.',
      placeHolder: 'Click to upload image',
      required: 'Please upload a product image'
    },
    productName: {
      label: 'Product Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Product name cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 2~50 characters; < > are not allowed'
    },
    firmwareType: {
      label: 'Firmware Type',
      placeHolder: 'Please enter firmware type',
      required: 'Firmware type cannot be empty, please confirm your input',
      invalid: 'Firmware type format is incorrect'
    },
    protocolIds: {
      label: 'Communication Method',
      placeHolder: 'Please select a communication method',
      required: 'Communication method cannot be empty, please confirm your input',
      invalid: 'Communication method format is incorrect'
    },
    productDesc: {
      label: 'Product Description',
      placeHolder: 'Valid string of 1~200 characters'
    },
    firmwareName: {
      label: 'Firmware Version Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Firmware version name cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 2~50 characters; < > are not allowed'
    },
    firmwareVision: {
      label: 'Firmware Version Number',
      placeHolder: 'Please enter firmware version number',
      required: 'Firmware version number cannot be empty, please confirm your input',
      invalid: 'Firmware version number format is incorrect'
    },
    firmwareTimeout: {
      label: 'Firmware Upgrade Timeout',
      placeHolder: 'Input range: 1~200',
      required: 'Firmware upgrade timeout cannot be empty, please confirm your input',
      invalid: 'Firmware upgrade timeout format is incorrect'
    },
    firmwareUpd: {
      label: 'Firmware Upgrade Method',
      placeHolder: 'Please select firmware upgrade method',
      required: 'Firmware upgrade method cannot be empty, please confirm your input'
    },
    firmwareRemark: {
      label: 'Version Description (Chinese)',
      placeHolder: 'Valid string of 1~200 characters',
      invalid: 'Version description format is incorrect'
    },

    firmwareFile: {
      label: 'Firmware File Upload',
      invalid:
        'Please provide a firmware file: formats include .bin, .img, .fw, .hex, .tar, .zip, .upg, .dmg, .fwu, .rpm, .tar, .gz, .tgz, .apk, .udata, .aab, with a maximum file size of 700MB.',
      placeHolder: 'Click to upload firmware file',
      required: 'Please upload a firmware file'
    },
    deviceName: {
      label: 'Mock Device Name',
      placeHolder: 'Valid string of 2~50 characters',
      required: 'Mock device name cannot be empty, please confirm your input',
      invalid: 'Please enter a valid string of 2~50 characters; < > are not allowed'
    },
    productId: {
      label: 'Product Selection',
      placeHolder: 'Please enter product ID to search for product information',
      required: 'Product ID cannot be empty, please confirm your input',
      invalid: 'Product ID format is incorrect'
    },
    deviceId: {
      label: 'Device ID',
      placeHolder: 'Please enter device ID',
      required: 'Device ID cannot be empty, please confirm your input',
      invalid: 'Device ID format is incorrect'
    },
    codeTip: {
      label: 'QR Code Content',
      placeHolder: 'Please enter QR code content',
      required: 'QR code content cannot be empty, please confirm your input'
    },
    langTxt: {
      label: 'Copywriting',
      required: 'Please enter the corresponding language entry copy',
      invalid: 'Incorrect language format'
    },
    scopeDevice: {
      required: 'The device ID/MAC cannot be empty. Please confirm the input.',
      invalid: 'The format of the device ID/MAC is incorrect.',
      placeHolder: 'Please enter the device ID/MAC'
    }
  },
  // 账号管理
  accountp: {
    user: {
      label: 'User Nickname',
      placeHolder: '2~50 valid characters',
      required: 'User nickname cannot be empty, please enter',
      invalid: 'Please enter 2~50 valid characters, no <> allowed'
    },
    account: {
      label: 'User Account',
      placeHolder: '5~50 valid characters, allowing a combination of letters, numbers, and symbol "-"',
      required: 'User account cannot be empty, please enter',
      invalid: 'Please enter 5~50 valid characters, allowing a combination of letters, numbers, and symbol "-"'
    },
    date: {
      label: 'Account Validity Period',
      placeHolder: 'Please select account validity period',
      required: 'Account validity period cannot be empty, please enter',
      invalid: 'Account validity period cannot be empty, please enter'
    }
  },
  // 客户管理
  client: {
    editBaseMsg: 'Edit Basic Information',
    editAdmin: 'Modify Administrator',
    pictureError: 'Please upload logo',
    name: {
      label: 'Full Name',
      required: 'Full name cannot be empty, please enter',
      invalid: 'Please enter 2~50 valid characters, no <> allowed',
      placeholder: '2~50 valid characters'
    },
    address: {
      label: 'Detailed Address',
      required: 'Detailed address cannot be empty, please enter',
      invalid: 'Invalid address format',
      placeholder: '2~200 valid characters'
    },
    domainName: {
      label: 'Domain Name',
      required: 'Domain name cannot be empty, please enter',
      invalid: 'Please enter a valid domain name, allowing letters, numbers, symbols . -',
      placeholder: 'Domain name format'
    },
    abbrName: {
      label: 'Abbreviation',
      required: 'Abbreviation cannot be empty, please enter',
      invalid: 'Please enter 2~50 valid characters, no <> allowed',
      placeholder: '2~50 valid characters'
    },
    dataCenter: {
      label: 'Data Center Region',
      required: 'Data center region cannot be empty, please select',
      invalid: 'Invalid data center region format',
      placeholder: 'Please select a data center region'
    },
    recordNumber: {
      label: 'Record Number',
      required: 'Record number cannot be empty, please enter',
      invalid: 'Invalid record number format',
      placeholder: '2~50 valid characters'
    },
    country: {
      label: 'Country/Region',
      required: 'Country/region cannot be empty, please enter',
      invalid: 'Invalid country/region format',
      placeholder: '2~200 valid characters'
    },
    city: {
      label: 'City',
      required: 'City cannot be empty, please enter',
      invalid: 'Invalid city format',
      placeholder: '2~200 valid characters'
    },
    creditCode: {
      label: 'Unified Social Credit Code',
      required: 'Unified social credit code cannot be empty, please enter',
      invalid: 'Invalid social credit code format',
      placeholder: '2~200 valid characters'
    },
    systemName: {
      label: 'System Name',
      required: 'System name cannot be empty, please enter',
      invalid: 'Invalid system name format',
      placeholder: '2~200 valid characters'
    },
    adminName: {
      label: 'Administrator Name',
      required: 'Administrator name cannot be empty, please enter',
      invalid: 'Invalid administrator name format',
      placeholder: '2~50 valid characters'
    },
    username: {
      label: 'User Account',
      required: 'User account cannot be empty, please enter',
      invalid: 'Invalid user account format',
      placeholder: '5~50 valid characters, allows letters, numbers, and symbols -'
    },
    email: {
      label: 'Email',
      required: 'Email cannot be empty, please enter',
      invalid: 'Invalid email format',
      placeholder: 'Email format'
    },
    logo: {
      label: 'Logo',
      invalid: 'Please provide a client logo: size 180x48 pixels, PNG format, file size no more than 3MB.',
      placeHolder: 'Click to upload image',
      required: 'Please upload logo image'
    }
  },

  dialog: {
    verify: 'Identity Verification',
    changeAdmin: 'Change Administrator'
  },
  backendErrorCode: {
    password: 'Incorrect password, please enter the correct password',
    500: 'Sorry, the server encountered a problem, please try again later or contact the technical support team.',
    403: 'Sorry, you do not have permission to access this content or perform this action. Please contact the administrator to obtain the necessary permissions.',
    401: 'Session expired, please log in again to continue.',
    503: 'Sorry, the server is temporarily unable to handle your request, please try again later.',
    miss: 'Unhandled error, please pay attention!',
    2011: 'Authorization signature expired or invalid, please adjust the system time or contact the technical support team.',
    codeFast: 'Verification code requests are too frequent, please try again later',
    accountNotFound: 'The account does not exist, please verify the input',
    checkCodeError: 'Verification code incorrect or expired, please verify the code or request a new one',
    groupSame: 'Function group name is duplicated, please enter again',
    categorySame: 'Standard category name is duplicated, please enter again',
    codeSame: 'Function identifier is duplicated, please enter again',
    funcNameSame: 'Function name is duplicated, please enter again',
    usedMail: 'This email is already in use',
    roleNameSame: 'Role name is duplicated, please enter again',
    roleUsed: 'The role is associated with accounts and must be unlinked before deletion',
    res1: 'Domain already exists',
    res2: 'Name already exists',
    res3: 'System name already exists',
    res4: 'There are users under the client being operated on, deletion is not allowed',
    res5: 'Application already exists',
    res6: 'Abbreviation already exists',
    res7: 'System name already exists',
    res8: 'User account already exists',
    res9: 'Product already exists',
    res10: 'Default tenant operation is prohibited',
    res11: 'User login error',
    res12: 'User does not have permission',
    res13: 'Sorry, the account validity period exceeds the time range, please reassign permissions',
    res14: 'The number of accounts exceeds the limit',
    res15: 'Illegal user account',
    res16: 'User account already exists',
    res17: 'Account is unavailable',
    res18: 'User has been blocked',
    res19: 'User has been locked',
    res20: 'Role does not exist',
    res21: 'The number of roles exceeds the limit',
    res22: 'Menu name already exists',
    res23: 'Menu permission already exists',
    res24: 'Menu does not exist',
    res25: 'Menu permission is empty',
    res26: 'Domain already exists',
    res27: 'Full name already exists',
    res28: 'System name already exists',
    res29: 'Record number already exists',
    res31: 'Unified social credit code already exists',
    1003009003: 'There are running devices under the product, deletion is not allowed',
    1003009001: 'Product name already exists, please enter again',
    1003009002: 'Product function group name already exists',
    1003009004: 'Product has been published',
    1003009005: 'Product does not exist',
    1003010001: 'Product firmware version already exists',
    1003010002: 'Product firmware file already exists',
    1003010003: 'Product firmware is in use',
    1003011001: 'Product firmware version already exists',

    1009007001: 'OTA task does not exist',
    1009007002: 'OTA task has been executed, cannot be deleted',
    1003007002: 'There is an unfinished OTA task for the device',
    1002000003: 'Device does not exist',
    1009005011: 'Client does not exist',
    1009001013: 'Account does not exist',
    1009005012: 'Client is disabled',
    1009004006: 'This standard category does not exist, please check and operate again',
    1009004007: 'The standard category has been released, please check and operate again',
    1009009001: 'The product does not exist, please check and operate again',
    1009009002: 'The product has been published. Please check and operate again',
    1001002006: 'The email address has been bound to another account. Please check and try again',
    1009010004: 'The firmware type does not exist.',
    1009010003: 'There are used firmware types among the deleted firmware types.',
    1009009003:
      'This firmware type is already in use by some firmware versions and cannot be deselected. Please handle the relevant firmware versions first.',
    1003007004: 'There is an error in the upgrade time of the OTA task that was created. ',
    '-1000000400': 'The current product has been listed, and this operation is not supported for now. ',
    1009011005: 'The application template name already exists, please use another name',
    1009011009: 'Please complete the configuration information before proceeding with the listing operation',
    1009011008: 'The current application template is associated with users and cannot be deleted',
    1009011007: 'The application name already exists, please use another name',
    1009011006: 'The version number already exists, please use another version number',
    1009011004: 'The application template does not exist, please check and try again',
    1009011003: 'The number of application templates exceeds the limit, and cannot continue to create',
    1009011002: 'The application resource has been listed and cannot be deleted',
    1009011001: 'The application does not exist, please check and try again',
    1009011011: 'Application h5 version is using',
    1009011012: 'Application not bind h5 version',
    1009011013: 'Application resource file exist',
    1009011018:
      'There is an error in the format of the field key name/field description/purpose/usage scenario in the imported JSON file',
    1009013001: 'Application policy version already exists',
    1009013002: 'Application policy version not exist',
    1009013003: 'Application policy version is used',
    1009013004: 'Data center not exist',
    1002000001: 'Device offline',
    1003012001: 'Getting device logs timed out',
    1003012002: 'Download device log timeout',
    1003012003: 'The device log switch is not turned on',
    1009011010: 'The current regional configuration already exists',
    1009011014: 'The same key name exists, please check and try again',

    1009005013: 'Tenant space not exist',
    1009005014: 'Tenant space unavailable',
    1009001014: 'User unauthorized'
  },
  layout: {
    help: 'Help Documentation'
  },
  icon: {
    fullscreen: 'Fullscreen',
    fullscreenExit: 'Exit Fullscreen',
    collapse: 'Collapse Menu',
    expand: 'Expand Menu'
  },
  datatable: {
    itemCount: 'Total {total} items'
  },
  langList: {
    afrikaans: 'afrikaans',
    ar: 'Arabic',
    az: 'Azerbaijani',
    be: 'Belgian',
    bg: 'Bulgarian',
    ca: 'Catalan',
    cs: 'Czech',
    cy: 'Welsh',
    da: 'Danish',
    de: 'German',
    dv: 'Devie language',
    el: 'Greek',
    en: 'English',
    en_US: 'English (USA)',
    en_GB: 'English (UK)',
    eo: 'Esperanto',
    es: 'Spanish',
    et: 'Estonian',
    eu: 'Bus language',
    fa: 'Farsi',
    fi: 'Finnish',
    fo: 'Faroese',
    fr: 'French',
    gl: 'Galician',
    gu: 'Gujarati',
    he: 'Hebrew',
    hi: 'Hindi',
    hr: 'Croatian',
    hu: 'Hungarian',
    hy: 'Armenian',
    id: 'Indonesian',
    is: 'ICELAND',
    it: 'Italian',
    ja: 'Japanese',
    ka: 'Georgian',
    kk: 'Kazakh',
    kn: 'Kanarese',
    ko: 'Korean',
    kok: 'Konkani',
    ky: 'Kyrgyz language',
    lt: 'Lithuanian',
    lv: 'latvian',
    mi: 'Maori language',
    mk: 'Macedonian language',
    mn: 'Mongolian',
    mr: 'Marathi language',
    ms: 'Malay',
    mt: 'Maltese',
    nb: 'Norwegian (Berkmel)',
    nl: 'Dutch',
    ns: 'Northern Sotho ',
    pa: 'Punjabi language',
    pl: 'Polish',
    pt: 'Portuguese',
    pt_BR: 'Portuguese (Brazil)',
    qu: 'Quechua',
    ro: 'Romanian',
    ru: 'Russian',
    sa: 'Sanskrit',
    se: 'North Samos language',
    sk: 'Slovak',
    sl: 'Slovenian language',
    sq: 'albanian',
    sv: 'Swedish',
    sw: 'Swahili',
    syr: 'Syriac language',
    ta: 'Tamil',
    te: 'Telugu language',
    th: 'Thai',
    tl: 'Tagalog',
    tn: 'tswana',
    tr: 'Turkish',
    ts: 'Zongjia language',
    tt: 'Tatar language',
    uk: 'Ukrainian',
    ur: 'Urdu',
    uz: 'Uzbek',
    vi: 'Vietnamese',
    xh: 'Bantu',
    zh: 'Chinese',
    zh_CN: 'Chinese (Simplified)',
    zh_HK: 'Chinese (Hong Kong)',
    zh_TW: 'Chinese (Traditional)',
    zu: 'Zulu'
  },
  upload: {
    title: 'Download or Import',
    uploadTip: 'Please upload a file',
    confirmUpload: 'Confirm Upload',
    result: 'Result',
    download: 'Download File',
    downloadAll: 'Download All Files',
    downloadCurrent: 'Download Current File',
    downloadTemplate: 'Download Template',

    menuFileName: 'Menu Translation File',
    allFileName: 'All Category Product Translation Files',
    currentFileName: 'Current Tab Translation File of Category Product',
    productAllFileName: 'All Product Translation Files',
    productCurrentFileName: 'Current Tab Translation File of Category',
    productName: 'Product Name Translation File',
    productGroup: 'Product Function Grouping Translation File',
    productFunction: 'Product Function Points Translation File',
    categoryName: 'Category Name Translation File',
    categoryGroup: 'Category Function Grouping Translation File',
    categoryFunction: 'Category Function Points Translation File',
    personalInfo: 'Personal Information Configuration Items',

    tipImportJson: 'Please provide a .json file',
    tip1: 'To ensure the accuracy of imported data, please download the template for editing',
    tip2: 'Note: After import, translations cannot be deleted, only overwritten',
    tip3: 'Please provide files in .xlsx or .xls format, with a size not exceeding 10MB',
    tip4: 'Please check and modify the following information before resubmitting!',
    tip5: 'The content you submitted has the following errors:',
    '001': 'Please check the file format; it is incorrect',
    '002': 'File content cannot be empty, please add content and try again',
    '003': 'File size exceeds the limit; please ensure the file is smaller than 10MB',
    '004':
      'The content of the entry is too long, please check and import again (128 characters in English, 50 characters in Chinese)',
    '005': 'Please use a supported language format',
    '006': 'Please use a supported language format'
  },
  mutilLang: {
    funcGroup: 'Function Group',
    func: 'Function Point',
    funcName: 'Function Name',
    no: 'Serial Number',
    code: 'Entry Code',
    langManger: 'Language Management',
    currCode: 'Current Entry',
    pleaseInput: 'Please enter the corresponding language entry copy',
    all: 'All:',
    selectedLang: 'Selected Languages:',
    set: 'Configure',
    tip1: 'If you need to add or remove languages, please go to',
    tip2: 'for configuration',
    tip3: 'If you need to add or remove languages, you can contact the current customer administrator for configuration.',
    tip4: 'The selected languages will apply to all products and apps; please configure the relevant texts.',
    tip5: 'A maximum of 20 languages can be selected',
    tip6: 'The default language cannot be canceled',
    category: {
      categoryName: 'Standard Product Name'
    },
    product: {
      productLang: 'Product Multilingual',
      productName: 'Product Name',
      tip: 'Set the multilingual texts related to the app'
    }
  },
  unit: {
    // 单位多语言待补充
    m: 'm',
    km: 'km',
    dm: 'dm',
    cm: 'cm',
    mm: 'mm',
    um: 'μm',
    nm: 'nm',
    m2: '㎡',
    km2: 'k㎡',
    mm2: 'm㎡',
    cm2: 'c㎡',
    hm2: 'h㎡',
    m3: 'm3',
    km3: 'km3',
    cm3: 'cm3',
    mm3: 'mm3',
    l: 'L',
    ml: 'mL',
    n: 'N',
    kg: 'kg',
    g: 'g',
    mg: 'mg',
    pa: 'Pa',
    kpa: 'kPa',
    hpa: 'hPa',
    mpa: 'mPa',
    c: '°C',
    t: 't',
    k: 'K',
    f: '℉',
    j: 'J',
    kj: 'kJ',
    ev: 'eV',
    wh: 'Wh',
    kwh: 'kW·h',
    cal: 'cal',
    w: 'W',
    kw: 'kW',
    mw: 'mW',
    uw: 'μW',
    hz: 'Hz',
    rad: 'rad',
    point: '°',
    min: '′',
    sed: '″',
    ms: 'm/s',
    kmh: 'km/h',
    kn: 'kn',
    year: 'year',
    month: 'month',
    week: 'week',
    day: 'day',
    h: 'h',
    minu: 'min',
    sedcond: 's',
    msed: 'ms',
    v: 'V',
    mv: 'mV',
    a: 'A',
    ka: 'kA',
    ma: 'mA',
    ua: 'μA',
    om: 'Ω',
    fala: 'F',
    ufala: 'μF',
    pfala: 'pF',
    nfala: 'nF',
    kgm3: 'kg/m3',
    gm3: 'g/m3',
    mgm3: 'mg/m3',
    ugm3: 'μg/m3',
    mgl: 'mg/L',
    gl: 'g/L',
    gml: 'g/mL',
    bit: 'bit',
    lm: 'lm',
    percent: '%',
    db: 'dB',
    grav: 'grav',
    lux: 'Lux',
    px: 'pixel',
    ppm: 'ppm',
    ugdm: 'μg/(d㎡·d)',
    b: 'B',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB',
    kcal: 'kcal',
    ugl: 'μg/L',
    kvar: 'KVar',
    kvarh: 'kvarh',
    m3h: 'm3/h',
    mpal: 'Mpa',
    ls: 'L/s',
    kclh: 'KCL/h',
    th: 't/h',
    rmin: 'r/min',
    kgs: 'kg/s',
    m3s: 'm3/s',
    rh: '%RH',
    uwcm2: 'uw/cm2',
    kvars: 'kvar',
    kva: 'KVA',
    kv: 'kV',
    nm3h: 'Nm3/h',
    stepCount: 'stepCount',
    gear: 'gear',
    count: 'count',
    turn: 'turn/m',
    mms: 'mm/s',
    mmol: 'mmol/L',
    mmHg: 'mmHg',
    mlmin: 'ml/min',
    vm: 'V/m',
    nc: 'N/C',
    uscm: 'uS/cm',
    ppb: 'ppb',
    ppt: 'ppt'
  },
  application: {
    title: 'Application Template List',
    versionCode: 'Version Code',
    versionName: 'Version Name',
    h5VersionCode: 'H5 Version Code',
    releaseStatus: 'Release Status',
    forceUpdate: 'Force Update',
    createTs: 'Create Ts',
    description: 'Description',
    resourceFile: 'Resource File',
    resourceLine: 'Resource Line',
    uploadResource: 'Upload Resource',
    detail: 'Detail',
    release: 'Release',
    unrelease: 'Unrelease',
    appName: 'Application Name',
    confirmRelease: 'Confirm Release',
    confirmUnrelease: 'Confirm Unrelease',
    releaseSuccess: 'Release Success',
    unreleaseSuccess: 'Unrelease Success',
    addSuccess: 'Add Success',
    updateSuccess: 'Update Success',
    pleaseInputVersionCode: 'Please enter version code/version name',
    addResource: 'Add Resource',
    editResource: 'Edit Resource',
    pleaseInputVersionName: 'Please enter version name',
    example: 'Example: 1.0.1',
    connectCode: 'Related Version Code',
    tip1: 'Please carefully fill in the version description (e.g.: 1. Fix xxx bug 2. Add xxx feature)',
    addAndroidTitle: 'Add Android Message Push Configuration',
    androidTitle: 'Android Message Push Configuration',
    addIosTitle: 'Add Ios Message Push Configuration',
    iosTitle: 'Ios Message Push Configuration',
    onePushAreaOnlyOneConfig: 'One push area can only have one configuration',
    noConfig: 'No Configuration',
    jiguang: 'Jpush',
    apns: 'Apns',
    firebase: 'Firebase',
    pushArea: 'Push Area',
    pushChannel: 'Push Channel',
    topic: 'Package Name',
    disCreName: 'Production Certificate',
    devCreName: 'Development Certificate',
    disCreNameFile: 'Production Certificate File',
    devCreNameFile: 'Development Certificate File',
    disCrePassword: 'Production Certificate Password',
    devCrePassword: 'Development Certificate Password',
    aliSms: 'Ali SMS',
    multiLogin: 'Multi-end Login',
    open: 'Open',
    close: 'Close',
    mixedDevelop: 'Mixed Development',
    mixedDevelopTip: '1、Enable APP mixed development, resource types: iOS, Android, H5',
    mixedDevelopTip2: '2、Disable APP mixed development, resource types: iOS, Android',
    appId: 'App ID',
    copy: 'Copy',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    appPic: 'App Picture',
    appPicTip:
      'Please provide the application image in PNG format, with a size of 290x230 pixels, in PNG format, and a file size not exceeding 3MB.',
    appPicReg: 'image/png,image/jpg,image/jpeg',
    appPicRegTip: 'Please provide an application picture, PNG format, and a file size of less than 3MB.',
    appPicRegTip2: 'Please provide an application picture, PNG format, and a file size of less than 3MB.',
    // 邮箱服务配置
    emailServe: 'Email Service Configuration',
    emailServeHost: 'Email Server Address',
    emailServePort: 'Port',
    emailServeUsername: 'Email Account',
    emailServePassword: 'Email Password',
    emailServeSender: 'Email Sender',
    emailServeSenderAlias: 'Email Sender Alias',
    // 短信验证码模板配置
    smsVerificationCode: 'SMS Verification Code Template Configuration',
    smsVerificationCodeSignName: 'SMS Signature',
    smsVerificationCodeTemplateCode: 'Template Code',
    // 邮箱验证码模板配置
    emailVerificationCode: 'Email Verification Code Template Configuration',
    emailVerificationCodeSender: 'Email Sender',
    emailVerificationCodeMailSubject: 'Email Subject',
    emailVerificationCodeMailTemplate: 'Email Template',
    // 资源文件上传
    addFirmwareFile: 'Resource File Upload',
    pleaseUploadApplicationResource: 'Please upload application resource',
    pleaseUploadApplicationResourceTip:
      'Please provide resource file: format as .apk, .ipa, .rar, .zip, file size not exceeding 700MB.',
    uploadHashFile: 'Upload Hash File',
    pleaseUploadHashFile: 'Please upload .hash file',
    hashFileInfo1: 'Upload .hash suffix file',
    hashFileInfo2: 'File size must not exceed 200KB',
    hashFileInfo3: 'SHA256 encryption will be applied',
    hashFileDescription: 'Only .hash format supported, max 200KB',
    hashFileFormatError: 'Only .hash format files are allowed',
    hashFileSizeExceed: 'File size must not exceed 200KB',
    // 创建应用
    createApplication: 'Create Application',
    applicationConfig: 'Application Config',
    more: 'More',
    versionManagement: 'Version Management',
    miniProgram: 'Mini Program',
    solutionDetail: 'Solution Detail',
    informationServiceConfig: 'Information Service Config',
    verificationCodeTemplateConfig: 'Verification Code Template Config',
    messagePush: 'Message Push',
    selectedApplicationTemplate: 'Selected Application Template：',
    reselect: 'Reselect',
    create: 'Create',
    private_key: 'private_key',
    app_key: 'app_key',
    master_secret: 'master_secret',
    database_url: 'database_url',
    accessKeySecret: 'accessKeySecret',
    accessKey: 'accessKey',
    remark: 'Remark',
    totalNum: 'Total',
    num: 'items',
    deleteConfirm: 'Are you sure you want to delete the current application?',
    iosLink: 'IOS resource link',
    iosSame: 'Consistent with historical versions',
    rules: {
      versionCode: 'Version code must be filled in three segments',
      versionCodeRange: 'Version code must be between 0 and 99',
      versionName: 'Version name is required',
      description: 'Version description is required',
      applicationTemplateName: 'Application template name is required',
      applicationName: 'Application name is required',
      applicationType: 'Application type is required',
      templateFile: 'Application template image is required',
      applicationRemark: 'Description content is required',
      password: 'Email password is required',
      port: 'Port is required',
      senderAlias: 'Sender alias is required',
      username: 'Email account is required',
      host: 'Email server address is required',
      accessKey: 'AccessKey is required',
      secretKey: 'SecretKey is required',
      region: 'RegionId is required',
      signName: 'SMS signature is required',
      templateCode: 'Template code is required',
      sender: 'Email sender is required',
      mailTemplate: 'Email template is required',
      mailSubject: 'Email subject is required',
      databaseUrl: 'Database URL is required',
      privateKey: 'Private key is required',
      appKey: 'App key is required',
      masterSecret: 'Master secret is required',
      accessSecret: 'AccessSecret is required',
      versionNameFile: 'Version name is required',
      descriptionFile: 'Version description is required',
      h5VersionCode: 'H5 version code is required',
      inputH5VersionCode: 'Please associate the H5 version number of this resource',
      dataCenterId: 'Push area is required',
      disCreNameFile: 'Please upload a p12 file with a size not exceeding 1MB.',
      disCreName: 'Production certificate cannot be empty.',
      topic: 'Application package name cannot be empty.',
      h5VersionCodeRelease: 'Unable to remove, the application associated with H5 has already been listed.',
      invalidLink: 'iOS resource link format is incorrect.',
      devCrePassword: 'Development certificate password is required',
      useDisCre: 'Whether to use the production certificate for development environment',
      inputAppKey: 'Please enter app_key',
      inputMasterSecret: 'Please enter master_secret',
      inputPrivateKey: 'Please enter private_key',
      inputDatabaseUrl: 'Please enter database_url',
      inputAccessKeySecret: 'Please enter accessKeySecret',
      inputVersionName: 'Please enter version name',
      inputTopic: 'Please enter application package name',
      uploadP12File: 'Please upload p12 type file, the size is less than 1MB',
      inputDisCrePassword: 'Please enter production certificate password',
      inputDevCrePassword: 'Please enter development certificate password',
      inputAccessSecret: 'Please enter AccessSecret',
      inputAccessKey: 'Please enter AccessKey',
      inputRegionId: 'Please enter RegionId',
      inputEmailServeHost: 'Please enter email server address',
      inputEmailServePort: 'Please enter port',
      inputEmailServeUsername: 'Please enter email account',
      inputEmailServePassword: 'Please enter email password',
      inputEmailServeSender: 'Please enter email sender',
      inputEmailServeSenderAlias: 'Please enter email sender alias',
      inputSmsVerificationCodeSignName: 'Please enter SMS signature',
      inputSmsVerificationCodeTemplateCode: 'Please enter template code',
      inputEmailVerificationCodeSender: 'Please enter email sender',
      inputEmailVerificationCodeMailSubject: 'Please enter email subject',
      inputEmailVerificationCodeMailTemplate: 'Please enter email template',
      inputApplicationName: 'Please enter application name',
      inputApplicationStatus: 'Please select application status',
      inputHost: 'Please enter valid ip or domain name format',
      inputPort: 'Please enter a number between 1 and 65535',
      inputIp: 'Please enter valid ip format',
      inputIosLink: 'Please enter the iOS resource link',
      protocolName: 'Protocol name cannot be empty',
      inputUserName: 'Please enter user name',
      inputProtocalType: 'Please select protocol type',
      inputVersion: 'Please enter version number',
      policyTypes: 'Application policy settings cannot be empty',
      versionCodeFormat: 'Version code format: major version number. minor version number. revision version number',
      stringEmpty: 'Input box cannot be empty'
    },
    status: {
      invalid: 'Invalid',
      pending: 'Pending',
      enabled: 'Enabled',
      invalidated: 'Invalidated',
      pendingApproval: 'Pending Approval',
      approve: 'Approve',
      reject: 'Reject'
    },
    protocolManage: 'Protocol Manage',
    addProtocol: 'Add Protocol',
    protocolName: 'Protocol Name',
    setLang: 'Set Language',
    currentVersion: 'Current Version',
    enableConfirm: 'After enabling, it will take effect immediately, are you sure you want to enable it?',
    enableConfirmContent: 'After enabling, the application user can see this protocol, no need to rebuild.',
    enableConfirmContent2:
      'Note: If you need to re-sign the protocol, please ensure that the re-signed content is configured completely',
    enable: 'Enable',
    protocolReSign: 'Protocol Re-sign Setting',
    deleteProtocol: 'Are you sure you want to delete this protocol?',
    deleteProtocolContent:
      'After deletion, the related data of the protocol will be deleted, and the protocol will no longer exist',
    addProtocolVersion: 'Add Version',
    userName: 'User Name',
    applicationName: 'Application Name',
    protocalType: 'Protocol Type',
    version: 'Version Number',
    protocolReSignContent:
      'After the protocol is re-signed, it will take effect forcefully. When you need to publish a new version of the user agreement or privacy policy, or make major modifications to the protocol, you can choose to enable and re-sign the operation in the corresponding App (the user will be forced to pop up a window when opening the App, and cannot enter or use unless they agree to sign).',
    protocolReSignExample: 'View Example',
    protocolReSignStatus: 'Protocol Re-sign Enable Status',
    parseDocxFileError: 'DOCX file parsing failed, please check if the file format is correct',
    parseMarkdownFileError: 'Markdown file parsing failed',
    parseHtmlFileError: 'HTML file parsing failed',
    unsupportedFileType: 'Unsupported file format, please upload DOCX file, file size not exceeding 3MB',
    unsupportedFileType2: 'Unsupported file format',
    fileImportSuccess: 'File import successful',
    fileParseError: 'File parsing failed, please check if the file format is correct',
    fileParsing: 'Parsing...',
    selectFile: 'Select File',
    filePreview: 'File Preview',
    openInNewWindow: 'Open in New Window',
    htmlContentPreview: 'HTML Content Preview',
    pleaseUploadFileToPreview: 'Please upload the file first to view the preview',
    pleaseInputexternalLink: 'Please enter the external link to view the preview',
    supportFileType: 'Support DOCX format',
    updateAttachment: 'Update Attachment',
    applicationPolicySetting: 'Application Policy Setting',
    privacyPolicy: 'Privacy Policy',
    userServiceProtocol: 'User Service Protocol',
    faceRecognitionServiceProtocol: 'Face Recognition Service Protocol',
    thirdPartyDataSharingExplanation: 'Third Party Data Sharing Explanation',
    privacyPolicySummary: 'Privacy Policy Summary',
    protocolVersionCode: 'Protocol Version Code',
    personalInformationCopyApplication: 'Personal Information Copy Application',
    privacyPolicyWithdrawalApplication: 'Privacy Policy Withdrawal Application',
    faceProtocolWithdrawalApplication: 'Face Protocol Withdrawal Application',
    preciseLocationWithdrawalApplication: 'Precise Location Withdrawal Application',
    approveConfirmContent: 'Are you sure you want to approve this application?',
    uploadFile: 'Upload File',
    externalLink: 'External Link',
    selectLanguage: 'Select Language',
    selectProtocolType: 'Select Protocol Type',
    inputExternalLink: 'Please enter the external link',
    editProtocolVersion: 'Edit Protocol Version',
    addProtocolVersionTitle: 'Add Protocol Version',
    forceUpdateLabel: 'Force Update',
    generatingPdf: 'Generating PDF...',
    updateType: 'Update Type',
    reminderInterval: 'Reminder Interval',
    supportZone: 'Applicable Region',
    minIosVersion: 'iOS Minimum Adaptation Version',
    minAndroidVersion: 'Android Minimum Adaptation Version',
    updateTypeOptions: {
      manualUpdate: 'Manual Update',
      reminderUpdate: 'Reminder Update',
      forceUpdate: 'Force Update',
      silentUpdate: 'Silent Update'
    },
    setUseRange: 'Set Use Range',
    useRange: 'Use Range',
    limitedRange: 'Limited Range',
    unlimitedRange: 'Unlimited Range',
    limitedRangeTip: 'Only customers with limited range can use this version function',
    unlimitedRangeTip: '*This version function is open to all users',
    quickAddAccount: 'Quick Add Account',
    addAccount: 'Add Account',
    pleaseInputAccount: 'Please enter account/phone number/email',
    switchTip: 'Switch Tip',
    switchTipContent:
      'Are you sure you want to switch to unlimited range? This will clear the gray users of the application!',
    uploadH5HashFile: 'Upload H5 hash file'
  },
  applicationTemplate: {
    title: 'Application Template Name',
    versionCode: 'Version Code',
    versionName: 'Version Name',
    h5VersionCode: 'H5 Version Code',
    releaseStatus: 'Release Status',
    goConfig: 'Go Config',
    createApplication: 'Create Application Template',
    templateLimit: 'Template Limit',
    applicationType: 'Application Type',
    desc: 'Description',
    applicationTemplateName: 'Application Template Name',
    mixedDevelop: 'Mixed Development',
    applicationTemplatePic: 'Application Template Picture',
    applicationTemplateRemark: 'Application Description',
    applicationTemplatePicTip:
      'Please provide an application template image with a size of 290x230 pixels, in PNG format, and a file size not exceeding 3M.',
    rules: {
      inputApplicationTemplateName: 'Please enter application template name',
      selectApplicationType: 'Please select application type',
      inputApplicationTemplateRemark: 'Please enter application description',
      inputApplicationTemplatePic: 'Please upload application template picture',
      listCheck:
        'Whether to list the application solution, after listing, the configuration information cannot be modified',
      unlistCheck: 'Whether to unlist the application solution, after unlisting, the current solution cannot be used'
    }
  }
};

export default local;
